import { IRuleToggleType } from "types/AdjustmentRules/AdjustmentRules";

import { api } from ".";

interface IToggleRuleEnabledRequest {
  ruleType: IRuleToggleType;
  ruleId: string;
  enabled: boolean;
}

/**
 * CLE-2547 — cross-type enable/disable for adjustment rules.
 *
 * One endpoint serves every rule type, so the toggle invalidates every rule list tag rather than
 * mapping ruleType → tag: the Payer Rules table renders all types as a single list, so a stale
 * entry in any one of them shows the wrong switch state.
 */
const adjustmentRuleQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    toggleRuleEnabled: builder.mutation<any, IToggleRuleEnabledRequest>({
      query: ({ ruleType, ruleId, enabled }) => ({
        url: `adjustment-rules/${ruleType}/${ruleId}/enabled`,
        method: "PATCH",
        body: { enabled },
      }),
      invalidatesTags: [
        "MpprRulesets",
        "CaseRateRulesets",
        "PackageRulesets",
        "ExplodingFeeScheduleRulesets",
        "InpatientRulesets",
        "ProfessionalRulesets",
        "InstitutionalRulesets",
        "ModifierAdjustmentRulesets",
        "LesserOfChargesRulesets",
        "ChargeBasedPricingRulesets",
        "UnitCapRulesets",
        "ContractHierarchyRules",
        // CLE-2264 — contract views derive their adjustment-rule lists from the
        // contract GET, so a toggle must also refresh any open contract pages.
        "ContractFeeSchedules",
      ],
    }),
  }),
});

export const { useToggleRuleEnabledMutation } = adjustmentRuleQueries;

export default adjustmentRuleQueries;
